'use strict';

import type { UserVoipPhoneNumber } from '../../Entities/User/UserVoipPhoneNumber';
import { EntityCollection } from '../EntityCollection';

export class UserVoipPhoneNumberCollection extends EntityCollection<UserVoipPhoneNumber> {}
